var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5882 29.1765C22.6451 29.1765 29.1765 22.6451 29.1765 14.5882C29.1765 6.53137 22.6451 0 14.5882 0C6.53137 0 0 6.53137 0 14.5882C0 22.6451 6.53137 29.1765 14.5882 29.1765Z",
    fill: "url(#paint0_linear_2947_113281)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5878 26.4403C21.134 26.4403 26.4407 21.1335 26.4407 14.5873C26.4407 8.04112 21.134 2.73438 14.5878 2.73438C8.04161 2.73438 2.73486 8.04112 2.73486 14.5873C2.73486 21.1335 8.04161 26.4403 14.5878 26.4403Z",
    fill: "#F5BE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1469 17.4992C19.1469 13.0343 12.5558 13.9069 12.5558 11.2691C12.5558 9.89235 14.104 9.81941 14.5881 9.81941C15.7515 9.81941 16.8748 10.1312 17.731 10.5333C18.0009 10.6601 18.3109 10.4722 18.3109 10.175V8.87574C18.3109 8.43991 18.1467 8.18188 17.8851 8.07977C17.2979 7.85183 16.4554 7.68497 15.209 7.64394V6.2143C15.209 6.04288 15.0704 5.9043 14.899 5.9043H14.279C14.1076 5.9043 13.969 6.04288 13.969 6.2143V7.66674C12.0343 7.85456 10.0293 8.94594 10.0293 11.4843C10.0293 16.1124 16.6204 15.1943 16.6204 17.6314C16.6204 18.3973 16.1308 19.0574 14.5881 19.0574C13.0372 19.0574 11.6121 18.5158 10.8234 18.1128C10.5581 17.977 10.2454 18.1739 10.2454 18.4721V19.9509C10.2454 20.2345 10.4159 20.4871 10.6776 20.5974C11.6121 20.994 12.8658 21.2949 13.9681 21.3824V22.9625C13.9681 23.1339 14.1067 23.2725 14.2781 23.2725H14.8981C15.0695 23.2725 15.2081 23.1339 15.2081 22.9625V21.3861C18.1011 21.1454 19.1469 19.2088 19.1469 17.4992Z",
    fill: "#FEE119"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2947_113281",
    x1: 4.57524,
    y1: 4.57524,
    x2: 24.8821,
    y2: 24.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct1);
export default __webpack_public_path__ + "static/media/product-1.0e5ff08968356e9035fdaec177993784.svg";
export { ForwardRef as ReactComponent };